import { CRUDEntity } from "../../abstracts/CRUDEntity";

export class CallingSettings extends CRUDEntity{
    constructor(){
        super();
        this.entityClass = 'call-setting';
        this.urlRoot = '/settings/cockpit';
        this.sectionRootUrl = '/settings';
    }
}
